import DgDialog from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDialog.install = function (Vue) {
  Vue.component(DgDialog.name, DgDialog)
}
export default DgDialog

export { DgDialog }